import { useTranslation } from 'react-i18next';
import { formatDate } from '~/lib';
import { LocalesType } from '~/types/uiTypes';

export default function ValuationUpdatedDate({
  date,
  className,
}: {
  date: string;
  className?: string;
}) {
  const { t, i18n } = useTranslation('app');
  const locale = i18n.language;
  if (!date) return <span></span>;

  return (
    <span className={`text-body_2 text-gray__dark_1 ${className}`}>
      {t('lastUpdated', {
        date: formatDate({
          value: date,
          format: 'gregorian',
          language: locale as LocalesType,
          removeDay: true,
        }),
      })}
    </span>
  );
}
